import { lazy } from 'react';

export const LazyIntegrationSendRemindersPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--integration-send-reminders-page" */ './integration-send-reminders-page'
    ),
);
